"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const faChevronLeft_1 = require("@fortawesome/pro-regular-svg-icons/faChevronLeft");
const createIcon_1 = __importDefault(require("./utils/createIcon"));
const ChevronLeftIcon = (0, createIcon_1.default)({
    displayName: 'ChevronLeftIcon',
    title: 'Chevron left icon',
    icon: faChevronLeft_1.faChevronLeft,
});
exports.default = ChevronLeftIcon;
